import { phonePattern } from '@/components/SmsCodeFormItem'
import i18n from '@/utils/i18n';

export const rules: any = {
  sdk: [{ required: true }, { type: 'string' }],
  type: [{ required: true }, { type: 'number' }],
  account: [{ required: true }, { type: 'string' }],
  password: [{ required: true }, { type: 'string' }],
  phone: [{ required: true }, { type: 'string' }, { pattern: phonePattern, message: `${i18n.t('user-center.login.rule-phone')}`, validateTrigger: 'onSubmit' }],
  agree: [{ validator: (rule, value) => value ? Promise.resolve() : Promise.reject(`${i18n.t('user-center.login.rule-agree')}`) }],
  openId: [{ required: true }, { type: 'string' }],
  userId: [{ required: true }, { type: 'string' }],
  code: [{ required: true }, { type: 'string' }],
}
